import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  EmailShareButton,
  TelegramShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  WhatsappIcon,
  EmailIcon,
  TelegramIcon,
} from "react-share";

import "./ShareButton.css";

const ShareButtons = ({ postUrl, postTitle, postDescription, postImg }) => {
  const title = "BeeTech | " + postTitle;
  const summary = postDescription;
  const source = "BeeTech";

  return (
    <div className="share-buttons">
      <EmailShareButton
        url={postUrl}
        quote={title}
        summary={summary}
        source={source}
        className="social-link"
      >
        <EmailIcon size={32} round />
      </EmailShareButton>

      <FacebookShareButton
        url={postUrl}
        quote={title}
        summary={summary}
        source={source}
        className="social-link"
      >
        <FacebookIcon size={32} round />
      </FacebookShareButton>

      <TwitterShareButton
        url={postUrl}
        title={title}
        summary={summary}
        source={source}
        className="social-link"
      >
        <TwitterIcon size={32} round />
      </TwitterShareButton>

      <LinkedinShareButton
        url={postUrl}
        title={title}
        summary={summary}
        source={source}
        className="social-link"
      >
        <LinkedinIcon size={32} round />
      </LinkedinShareButton>

      <TelegramShareButton
        url={postUrl}
        title={title}
        summary={summary}
        source={source}
        className="social-link"
      >
        <TelegramIcon size={32} round />
      </TelegramShareButton>

      <WhatsappShareButton
        url={postUrl}
        title={title}
        summary={summary}
        source={source}
        className="social-link"
      >
        <WhatsappIcon size={32} round />
      </WhatsappShareButton>
    </div>
  );
};

export default ShareButtons;
